import { render } from "./BankTable.vue?vue&type=template&id=3324e554"
import script from "./BankTable.vue?vue&type=script&lang=js"
export * from "./BankTable.vue?vue&type=script&lang=js"

import "./BankTable.vue?vue&type=style&index=0&id=3324e554&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__